<template>
    <div
        class="richTable-row t-promos-row js-collapse-head align-items-center pt-0"
        :class="{
            'is-open':
                activePromoLocal === promotion.id &&
                previewType !== 'group-accept' &&
                previewType !== 'labels'
        }"
    >
        <div
            v-if="previewType !== 'group-accept' && previewType !== 'labels'"
            class="richTable-col t-promos-name"
        >
            <span class="typo--label order-2 order-lg-1">
                {{ promoType }}
                <span class="d-lg-none">
                    od
                    {{
                        $moment(promotion.start_at).format('DD-MM-YYYY, HH:mm')
                    }}
                    do
                    {{
                        $moment(promotion.end_at).format('DD-MM-YYYY, HH:mm')
                    }}
                </span>
            </span>
            <h3 class="h6 richTable-title mb-1 mb-lg-0 mr-2 order-1 order-lg-2">
                {{ promotion.name }}
            </h3>
            <a-icon
                class="text-danger shops-unchecked"
                v-if="allSubInterrupted"
                icon="Info"
                v-tooltip="{
                    content: allSubInterruptedError
                }"
            />
            <a-icon
                class="text-danger shops-unchecked"
                v-else-if="allShopsUnchecked"
                icon="Info"
                v-tooltip="{
                    content: allShopsUncheckedError
                }"
            />
        </div>
        <div
            v-if="previewType !== 'group-accept' && previewType !== 'labels'"
            class="richTable-col t-promos-actions"
        >
            <template v-if="!fromSinglePromo">
                <the-btn
                    :text="'Dostosuj w sklepach'"
                    @click.native="activateShops"
                    btn-class="btn-show-shops btn-outline-secondary flex-grow-1 d-flex"
                    :icon="'Filter'"
                ></the-btn>
            </template>
            <the-btn
                @click.native="deselectPromo(promotion.id)"
                btn-class="btn-outline btn-icon is-danger"
                :icon="'Bin'"
            ></the-btn>
        </div>
        <div
            class="t-shops-container"
            :class="{
                '-noPadding':
                    previewType === 'group-accept' || previewType === 'labels'
            }"
            v-if="activePromoLocal === promotion.id"
        >
            <a-switch
                v-if="
                    promotion.type !== PROMO_TYPES.QUOTA &&
                        promotion.type !== PROMO_TYPES.SALES_TARGET &&
                        !isNoItemsPromo
                "
                :checked="
                    promotion.subscriptionsEqualPrices &&
                        promotion.subscriptionsEqualPrices.equalPrices
                "
                @change="onEqualPricesSwitch"
                :text="
                    `${
                        promotion.type.includes('RegularPrice') &&
                        previewType === 'labels'
                            ? 'Jednakowa liczba kopii w wybranych sklepach'
                            : 'Jednakowa cena w wybranych sklepach'
                    }`
                "
            />
            <a-switch
                v-if="
                    previewType !== 'labels' &&
                        !promotion.all_eans_present &&
                        !hasSets
                "
                :checked="promotion.equalLocalCodes"
                @change="onLocalCodesSwitch"
                text="Jednakowy kod lokalny w wybranych sklepach"
            />
            <page-preloader
                v-if="
                    promotion.productsStatus === 'loading' &&
                        !promotion.products.length &&
                        !promotion.product_sets
                "
                min-height="123px"
            />

            <subscriptions-equal-prices
                :class="{ show: activePromoLocal === promotion.id }"
                :promotion="promotion"
                :preview-type="previewType"
                :group-id="groupId"
                v-if="
                    (promotion.subscriptionsEqualPrices &&
                        promotion.subscriptionsEqualPrices.equalPrices) ||
                        promotion.equalLocalCodes
                "
                :show-price-lowest="showPriceLowestInput"
                :show-price-lowest-discount="showPriceLowestDiscountInput"
            />
            <div
                v-else
                class="t-shops-wrapper collapse richTable-col"
                :class="{ show: activePromoLocal === promotion.id }"
                style="--width-md: 100%"
            >
                <div class="t-shops-settings" v-if="!allSubInterrupted && !allCheckedSubsAreInterrupted">
                    <div class="custom-checkbox">
                        <the-btn
                            text="Zaznacz wszystkie"
                            class="btn-outline-custom d-none d-sm-inline-flex"
                            :class="{ 'd-inline-flex': !allowSelectAll }"
                            icon="CheckCorrect"
                            @click.native="selectAllShops(true)"
                        />
                        <the-btn
                            text="Odznacz wszystkie"
                            class="
                            btn-danger
                            ml-sm-2
                            d-none d-sm-inline-flex
                        "
                            :class="{ 'd-inline-flex': allowSelectAll }"
                            icon="CheckIncorrect"
                            @click.native="selectAllShops(false)"
                        />
                    </div>
                </div>
                <div class="t-shops overflow-visible">
                    <div class="scrollbar-shadow is-top"></div>
                    <div
                        v-if="allSubInterrupted"
                        class="t-shops-error text-danger typo--sm"
                    >
                        {{ allSubInterruptedError }}
                    </div>
                    <div
                        v-else-if="allCheckedSubsAreInterrupted"
                        class="t-shops-error text-danger typo--sm"
                    >
                        Promocja została przerwana w wybranych sklepach i nie zostanie
                        wysłana do aktywacji. Ponowna aktywacja będzie możliwa jutro
                    </div>
                    <div
                        v-else-if="allShopsUnchecked"
                        class="t-shops-error mb-3 text-danger typo--sm"
                    >
                        {{ allShopsUncheckedError }}
                    </div>
                    <promotion-shop
                        v-for="(sub, idx) in searchedShopsIds"
                        :subscriptions="promotion.subscriptions"
                        :key="idx"
                        :sub="sub"
                        :group-id="groupId"
                        :price-group-idx="priceGroupIdx"
                        :promotion="promotion"
                        :active-shop="activeShop"
                        @onChangeActiveShop="activeShop = $event"
                        :selected-shops="promotionShops"
                        :preview-type="previewType"
                        :show-price-lowest="showPriceLowestInput"
                        :show-price-lowest-discount="
                            showPriceLowestDiscountInput
                        "
                    ></promotion-shop>
                    <div class="scrollbar-shadow is-bottom"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PromotionShop from '@/components/promotions/PromotionShop'
import SubscriptionsEqualPrices from '@/components/promotions/SubscriptionsEqualPrices'
import ASwitch from '../global/ui/ASwitch.vue'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    data() {
        return {
            activeShop: 0,
            allShopsUncheckedError: 'Wybierz sklep lub usuń promocję z koszyka',
            allSubInterruptedError:
                'Promocja została przerwana we wszystkich sklepach, aktywacja będzie możliwa jutro'
        }
    },
    components: {
        PromotionShop,
        SubscriptionsEqualPrices,
        ASwitch
    },
    props: {
        promotion: {
            type: Object,
            required: true
        },
        merchants: {
            type: Array,
            required: true
        },
        fromSinglePromo: {
            type: Boolean,
            required: true
        },
        activePromo: {
            type: Number,
            required: true
        },
        groupId: {
            type: Number,
            required: true
        },
        priceGroupIdx: {
            type: Number,
            required: true
        },
        previewType: {
            type: String,
            default: ''
        }
    },
    created() {
        this.PROMO_TYPES = PROMO_TYPES
    },
    methods: {
        deselectPromo(promoId) {
            this.$store.dispatch('selectPromotion', {
                id: promoId,
                value: false
            })
            this.$store.dispatch('setSelectAllPromotions', false)
        },
        selectAllShops(value) {
            this.$store.dispatch('selectAllMerchants', {
                promoId: this.promotion.id,
                shops: this.searchedShopsIds,
                value,
                promotion: this.promotion,
                previewType: this.previewType,
                fromPromoDetails: this.$store.getters.modalState?.args
                    ?.singleSubscription
            })
        },
        activateShops() {
            if (this.activePromoLocal !== this.promotion.id) {
                this.activePromoLocal = this.promotion.id
            } else {
                this.activePromoLocal = 0
            }
        },
        onEqualPricesSwitch($val) {
            this.$store.dispatch('setPromotionEqualPrice', {
                val: $val,
                promoId: this.promotion.id,
                groupId: this.groupId,
                previewType: this.previewType
            })
            this.$store.dispatch('checkPricesErrors')
        },
        onLocalCodesSwitch(val) {
            this.$store.dispatch('setPromotionEqualLocalCodes', {
                val,
                promoId: this.promotion.id,
                groupId: this.groupId,
                previewType: this.previewType
            })
        },
        expandFirstSelectedShop() {
            const isWeight =
                this.$store.getters.isWeight(this.promotion.type) &&
                !this.promotion.equalLocalCodes

            if (
                !this.activeShop &&
                !this.promotion.subscriptionsEqualPrices.equalPrices &&
                (this.previewType === 'labels' || isWeight)
            ) {
                const firstSelectedShop = this.promotion.subscriptions.find(
                    el => {
                        if (this.previewType === 'group-accept') {
                            return (
                                el.checked &&
                                el.state === 'available' &&
                                !el.suspended
                            )
                        } else if (this.previewType === 'labels') {
                            return (
                                el.checked &&
                                el.state === 'accepted' &&
                                !el.suspended
                            )
                        }
                        return el.checked
                    }
                )
                if (firstSelectedShop) {
                    this.activeShop = firstSelectedShop.merchant_id
                }
            }
        }
    },

    computed: {
        promotionShops() {
            const payload = {
                promoId: this.promotion.id,
                groupId: this.promotion.promo_group_id
            }
            if (this.previewType === 'labels') {
                return this.$store.getters.getPromotionLabelShops(payload)
            } else {
                return this.$store.getters.getPromotionShops(payload)
            }
        },
        isEveryShopSelectionUndefined() {
            return this.promotionShops?.every(el => el.checked === undefined)
        },
        allShopsUnchecked() {
            return this.$store.getters.atLeastOneOfSelectedPromotionsHasNoSubsActive(
                {
                    promotion: this.promotion,
                    state:
                        this.previewType === 'labels' ? 'accepted' : 'available'
                }
            )
        },
        allSubInterrupted() {
            return (
                this.previewType === 'group-accept' &&
                this.$store.getters.atLeastOneOfSelectedPromotionsHasNoSubsActive(
                    {
                        promotion: this.promotion,
                        state: 'interrupted'
                    }
                )
            )
        },
        allCheckedSubsAreInterrupted() {
            return this.previewType === 'group-accept' &&
            this.$store.getters.allCheckedSubsAreInterrupted(this.promotion)
        },
        availableMerchantIds() {
            return this.$store.getters.getAvailableMerchants.map(el => el.id)
        },
        searchedShopsIds() {
            /* return ids array of available shops */
            if (this.previewType === 'labels') {
                return this.promotionShops
                    .filter(el => el !== undefined && el.state === 'accepted')
                    .filter(el =>
                        this.availableMerchantIds.includes(el.merchant_id)
                    )
                    .map(el => el.merchant_id)
            } else {
                return this.promotionShops
                    .filter(el => el !== undefined && el.state === 'available')
                    .filter(el =>
                        this.availableMerchantIds.includes(el.merchant_id)
                    )
                    .map(el => el.merchant_id)
            }
        },
        promoType() {
            return this.$store.getters.getPromoTypeByValue(this.promotion.type)
        },
        allowSelectAll() {
            return (
                this.promotion.subscriptions.length ===
                this.promotion.subscriptions.filter(el => el.checked).length
            )
        },
        activePromoLocal: {
            get() {
                return this.activePromo
            },
            set(value) {
                this.$emit('onChangeActivePromo', value)
            }
        },
        showPriceLowestInput() {
            return (
                this.previewType === 'labels' &&
                (this.promotion.type === PROMO_TYPES.MIX1 ||
                this.promotion.type === PROMO_TYPES.PROMO_ITEM_FIXED_PRICE ||
                    (this.promotion.type === PROMO_TYPES.PERIODIC_PRICE_REDUCTION &&
                        this.promotion.loyalty))
            )
        },
        showPriceLowestDiscountInput() {
            return (
                this.previewType === 'labels' &&
                this.promotion.type === PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION &&
                this.promotion.loyalty
            )
        },
        isNoItemsPromo() {
            return this.$store.getters.isNoItemsPromo(this.promotion.type)
        },
        hasSets() {
            return this.$store.getters.hasProductSets(this.promotion.type)
        }
    },

    async mounted() {
        if (this.previewType === 'labels') {
            await this.$store.dispatch('loadLabelsResources', {
                promo: this.promotion
            })
        }

        this.$nextTick(() => {
            this.expandFirstSelectedShop()
        })
    },

    watch: {
        isEveryShopSelectionUndefined() {
            setTimeout(() => {
                this.expandFirstSelectedShop()
            }, 0)
        },
        'promotion.subscriptionsEqualPrices.equalPrices'() {
            this.expandFirstSelectedShop()
        }
    }
}
</script>
